import { Fragment, type ReactNode } from "react";
import classnames from "classnames";

import style from "./style.module.scss";
import Logo from "../logo";
import { LoginButton, Username, AdminLink, CliTokenButton } from "../../../security";
import Footer from "../footer";

interface PageProps {
  children?: ReactNode;
  isFullscreen?: boolean;
}

function Page({ children, isFullscreen = false }: PageProps) {
  return (
    <Fragment>
      <header className={style.header}>
        <div className={style.left}>
          <Logo />
        </div>
        <div className={style.right}>
          <AdminLink />
          <CliTokenButton />
          <Username />
          <LoginButton />
        </div>
      </header>
      <div
        className={classnames(style.container, {
          [style.isFullscreen]: isFullscreen,
        })}
      >
        {children}
      </div>
      <Footer className={style.footer} />
    </Fragment>
  );
}

export default Page;
